import React from "react";
export default function PriorityIcon({
  prioritycode,
  priorityname,
  className,
  showAll,
}) {
  let icons = {
    low: "fa fa-angle-double-down text-dark opacity-25",
    medium: showAll ? "fa fa-angle-double-down  text-primary opacity-50" : "",
    high: "fa fa-angle-double-up  text-warning",
    critical: "fa fa-angle-double-up text-danger",
  };
  let icon = icons[prioritycode];
  if (icon) {
    return (
      <i
        title={`Приоритет: ${priorityname}`}
        className={`${icons[prioritycode]} ${className}`}
      ></i>
    );
  }
  return null;
}
